import React from 'react'
import { useLocation } from 'react-router-dom'

import ApartmentErrorBoundary from './ApartmentErrorBoundary'

/**
 * Wrap an apartment page so a crash in it cannot take Alfred down.
 *
 * Applied once, where the pages are registered, rather than edited into all 17
 * page files. `resetKey` is the route, so navigating to another page clears a
 * previous crash instead of leaving the admin stuck on the fallback.
 */
const withApartmentBoundary = (Page) => {
  const Wrapped = (props) => {
    const location = useLocation()
    return (
      <ApartmentErrorBoundary resetKey={location.pathname}>
        <Page {...props} />
      </ApartmentErrorBoundary>
    )
  }
  Wrapped.displayName = `withApartmentBoundary(${
    Page.displayName || Page.name || 'Page'
  })`
  return Wrapped
}

export default withApartmentBoundary
